import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './portal.css';

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 44c5.5 0 10.4-2.1 14.1-5.5l-6.5-5.5c-2 1.5-4.7 2.5-7.6 2.5-5.2 0-9.6-3.3-11.2-8l-6.5 5C9.6 39.6 16.2 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4.1 5.5l6.5 5.5C41.4 36.5 44 30.8 44 24c0-1.3-.1-2.3-.4-3.5z"/>
  </svg>
);

const Login = ({ heading = 'Client Portal', sub = 'Sign in to manage your project, payments, and deliverables.' }) => {
  const { signInWithGoogle } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const handleSignIn = async () => {
    setBusy(true); setErr('');
    try {
      await signInWithGoogle(window.location.pathname + window.location.search);
    } catch (e) {
      setErr(e.message || 'Sign-in failed');
      setBusy(false);
    }
  };

  return (
    <div className="portal" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="portal-card" style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <p className="portal-eyebrow">qalvin.dev</p>
        <h1 className="portal-title" style={{ fontSize: 32 }}>{heading}</h1>
        <p className="portal-sub" style={{ margin: '10px auto 28px' }}>{sub}</p>
        <button className="portal-btn portal-btn-ghost portal-btn-block" onClick={handleSignIn} disabled={busy}
          style={{ background: '#fff', border: '1.5px solid rgba(23,20,18,0.15)', padding: '14px' }}>
          <GoogleIcon />
          {busy ? 'Redirecting…' : 'Continue with Google'}
        </button>
        {err && <p style={{ color: 'var(--v2-color-error)', fontSize: 12, marginTop: 14 }}>{err}</p>}
        <p className="portal-muted" style={{ fontSize: 11, marginTop: 22 }}>
          By continuing you agree to our <a href="/terms" style={{ color: 'inherit' }}>Terms</a> and{' '}
          <a href="/privacy" style={{ color: 'inherit' }}>Privacy Policy</a>.
        </p>
      </div>
    </div>
  );
};

export default Login;
